import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';
import { getStoredRole, getTopNavLinks } from '../utils/navigation';

const C = { bg: '#0A0E1A', surface: '#111827', border: '#1F2937', accent: '#10B981', text: '#F9FAFB', muted: '#6B7280' };
const s = {
  page: { minHeight: '100vh', background: C.bg, color: C.text, fontFamily: "'DM Sans','Segoe UI',sans-serif" },
  topbar: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '20px 32px', borderBottom: `1px solid ${C.border}`, background: C.surface },
  logo: { fontSize: 20, fontWeight: 700, color: C.accent },
  nav: { display: 'flex', gap: 24, flexWrap: 'wrap' },
  navLink: (active) => ({ color: active ? C.accent : C.muted, textDecoration: 'none', fontSize: 14, fontWeight: active ? 700 : 400 }),
  main: { padding: 32, maxWidth: 1200, margin: '0 auto' },
  heading: { fontSize: 26, fontWeight: 700, marginBottom: 4 },
  sub: { fontSize: 14, color: C.muted, marginBottom: 24 },
  card: { background: C.surface, border: `1px solid ${C.border}`, borderRadius: 14, overflow: 'hidden' },
  table: { width: '100%', borderCollapse: 'collapse' },
  th: { textAlign: 'left', fontSize: 11, color: C.muted, textTransform: 'uppercase', letterSpacing: '0.06em', padding: '12px 16px', borderBottom: `1px solid ${C.border}` },
  td: { padding: '12px 16px', fontSize: 13, borderBottom: `1px solid ${C.border}22` },
  empty: { textAlign: 'center', padding: '48px 0', color: C.muted }
};

export default function Transactions() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const role = getStoredRole();
  const links = getTopNavLinks(role);

  useEffect(() => {
    const load = async () => {
      try {
        const r = await api.get('/transactions');
        setItems(Array.isArray(r.data) ? r.data : []);
      } catch {
        setItems([]);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  return (
    <div style={s.page}>
      <div style={s.topbar}>
        <div style={s.logo}>⚡ FintechCoop</div>
        <nav style={s.nav}>{links.map(link => <Link key={link.to} to={link.to} style={s.navLink(link.to === '/transactions')}>{link.label}</Link>)}</nav>
      </div>
      <div style={s.main}>
        <div style={s.heading}>Transacciones</div>
        <div style={s.sub}>Trazabilidad de movimientos financieros</div>
        <div style={s.card}>
          {loading ? <div style={s.empty}>Cargando transacciones...</div> : items.length === 0 ? <div style={s.empty}>Sin datos disponibles</div> : (
            <table style={s.table}>
              <thead><tr>{['ID', 'Tipo', 'Monto', 'Estado', 'Fecha'].map(h => <th key={h} style={s.th}>{h}</th>)}</tr></thead>
              <tbody>
                {items.map((t) => (
                  <tr key={t.id || t.transaction_id}>
                    <td style={s.td}>{t.transaction_id || t.id}</td>
                    <td style={s.td}>{t.transaction_type || '—'}</td>
                    <td style={s.td}>{t.amount ?? '—'}</td>
                    <td style={s.td}>{t.status || '—'}</td>
                    <td style={s.td}>{t.created_at ? new Date(t.created_at).toLocaleString('es-EC') : '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
}
